/**
 * Typical color / pattern swatches for TNWS color filter labels.
 * CSS-only — no external images.
 */
(function () {
  const SWATCHES = {
    animal: {
      background:
        'radial-gradient(circle at 25% 35%, #5c3d1e 3px, transparent 3px), radial-gradient(circle at 65% 55%, #5c3d1e 2.5px, transparent 2.5px), radial-gradient(circle at 45% 75%, #5c3d1e 2px, transparent 2px), linear-gradient(145deg, #c9a227 0%, #a67c00 55%, #8b6914 100%)',
      backgroundSize: '14px 14px, 12px 12px, 10px 10px, 100% 100%',
    },
    beige: { color: '#e8dcc8', light: true },
    black: { color: '#1a1a1a' },
    blue: { color: '#2563eb' },
    bronze: { color: '#a97142' },
    brown: { color: '#7c4a2d' },
    camouflage: {
      background:
        'radial-gradient(ellipse 45% 55% at 22% 32%, #4a5d23 0%, transparent 100%), radial-gradient(ellipse 40% 50% at 72% 58%, #3d2914 0%, transparent 100%), radial-gradient(ellipse 35% 45% at 48% 78%, #6b7c3c 0%, transparent 100%), #2d3a1a',
    },
    checkered: {
      background: 'repeating-conic-gradient(#24304a 0% 25%, #f5f5f5 0% 50%) 50% / 10px 10px',
    },
    clear: { color: 'rgba(255, 255, 255, 0.35)', light: true, translucent: true },
    copper: { color: '#b87333' },
    dots: {
      background:
        'radial-gradient(circle, #24304a 1.5px, transparent 1.5px), #f3f4f6',
      backgroundSize: '9px 9px',
    },
    floral: {
      background:
        'radial-gradient(circle at 38% 38%, #f4a6b8 14%, transparent 16%), radial-gradient(circle at 62% 68%, #98d8aa 11%, transparent 14%), radial-gradient(circle at 52% 48%, #ffd6e8 8%, transparent 10%), #faf0f3',
    },
    geometric: {
      background:
        'linear-gradient(45deg, #24304a 25%, transparent 25%), linear-gradient(-45deg, #24304a 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #d4af7a 75%), linear-gradient(-45deg, transparent 75%, #d4af7a 75%)',
      backgroundSize: '10px 10px',
      backgroundPosition: '0 0, 0 5px, 5px -5px, -5px 0',
    },
    gold: { color: '#d4af37' },
    gray: { color: '#9ca3af' },
    green: { color: '#16a34a' },
    multicolor: {
      background: 'linear-gradient(135deg, #ef4444 0%, #f59e0b 20%, #eab308 40%, #22c55e 60%, #3b82f6 80%, #a855f7 100%)',
    },
    navy: { color: '#1e3a5f' },
    orange: { color: '#ea580c' },
    pink: { color: '#f472b6' },
    plaid: {
      background:
        'repeating-linear-gradient(0deg, transparent, transparent 6px, rgba(30, 58, 95, 0.35) 6px, rgba(30, 58, 95, 0.35) 7px), repeating-linear-gradient(90deg, #8b1a1a, #8b1a1a 10px, #1e3a5f 10px, #1e3a5f 20px)',
    },
    purple: { color: '#7c3aed' },
    rainbow: {
      background: 'linear-gradient(90deg, #ef4444, #f97316, #eab308, #22c55e, #3b82f6, #8b5cf6)',
    },
    red: { color: '#dc2626' },
    'rose gold': { color: '#b76e79' },
    silver: { color: '#c5c9d1', light: true },
    striped: {
      background: 'repeating-linear-gradient(90deg, #24304a 0, #24304a 5px, #f8fafc 5px, #f8fafc 10px)',
    },
    'tie-dye': {
      background:
        'radial-gradient(circle at 28% 28%, #ff6b9d 0%, transparent 48%), radial-gradient(circle at 72% 68%, #4ecdc4 0%, transparent 45%), radial-gradient(circle at 50% 50%, #ffe66d 0%, transparent 55%), #c44569',
    },
    white: { color: '#ffffff', light: true },
    yellow: { color: '#eab308' },
  };

  function normalizeKey(label) {
    return String(label || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }

  function getSwatch(label) {
    const key = normalizeKey(label);
    if (!key) return null;
    return SWATCHES[key] || null;
  }

  function applyToElement(element, label) {
    if (!element) return;
    element.classList.remove(
      'tnws-fav-filters__color-swatch--light',
      'tnws-fav-filters__color-swatch--translucent'
    );
    element.style.background = '';
    element.style.backgroundImage = '';
    element.style.backgroundSize = '';
    element.style.backgroundPosition = '';

    const swatch = getSwatch(label);
    if (!swatch) {
      element.hidden = true;
      return;
    }

    element.hidden = false;
    if (swatch.color) {
      element.style.background = swatch.color;
    } else if (swatch.background) {
      element.style.background = swatch.background;
      if (swatch.backgroundSize) element.style.backgroundSize = swatch.backgroundSize;
      if (swatch.backgroundPosition) element.style.backgroundPosition = swatch.backgroundPosition;
    }
    if (swatch.light) element.classList.add('tnws-fav-filters__color-swatch--light');
    if (swatch.translucent) element.classList.add('tnws-fav-filters__color-swatch--translucent');
  }

  function createSwatchElement(label) {
    const swatch = document.createElement('span');
    swatch.className = 'tnws-fav-filters__color-swatch';
    swatch.setAttribute('aria-hidden', 'true');
    applyToElement(swatch, label);
    return swatch;
  }

  window.TnwsColorSwatches = {
    getSwatch,
    applyToElement,
    createSwatchElement,
  };
})();
